export const color1 = '#6AA8FF'
export const color2 = '#3168CE'
export const color3 = '#5353D1'
export const color4 = '#FFFFFF'
//export const emailCheck = /^(?=.*[a-zA-Z])[a-zA-Z\d@$!#%*_\-.?&^():;,.\\'"{}]*@(?=.*[a-z])[a-zA-Z\d@$!#%*_\-.?&^():;,.\\'"{}]*\.(?=.*[a-z])[a-z]{2,}/
export const  emailCheck = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
export const pwdCheck = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@.\-$!%#*_.?&^():;,.\\'"{}])[A-Za-z\d@.\-_$^!#%*?&]{8,15}$/
export const handleAlphabetCheck = (val) => {
  const alphabets = /^[a-zA-Z\s\b]+$/i
  // ^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$
  if (alphabets.test(val) && !onlySpaces(val)) {
    return 1
  }
  return 0
}
function onlySpaces(str) {
  return str.trim().length === 0;
}
export const arabicValue = (txt) => {
  let yas = txt
  yas = yas.replace(/`/g, 'ذ')
  yas = yas.replace(/0/g, '۰')
  yas = yas.replace(/1/g, '۱')
  yas = yas.replace(/2/g, '۲')
  yas = yas.replace(/3/g, '۳')
  yas = yas.replace(/4/g, '٤')
  yas = yas.replace(/5/g, '۵')
  yas = yas.replace(/6/g, '٦')
  yas = yas.replace(/7/g, '۷')
  yas = yas.replace(/8/g, '۸')
  yas = yas.replace(/9/g, '۹')
  yas = yas.replace(/0/g, '۰')
  yas = yas.replace(/q/g, 'ض')
  yas = yas.replace(/w/g, 'ص')
  yas = yas.replace(/e/g, 'ث')
  yas = yas.replace(/r/g, 'ق')
  yas = yas.replace(/t/g, 'ف')
  yas = yas.replace(/y/g, 'غ')
  yas = yas.replace(/u/g, 'ع')
  yas = yas.replace(/i/g, 'ه')
  yas = yas.replace(/o/g, 'خ')
  yas = yas.replace(/p/g, 'ح')
  yas = yas.replace(/\[/g, 'ج')
  yas = yas.replace(/\]/g, 'د')
  yas = yas.replace(/a/g, 'ش')
  yas = yas.replace(/s/g, 'س')
  yas = yas.replace(/d/g, 'ي')
  yas = yas.replace(/f/g, 'ب')
  yas = yas.replace(/g/g, 'ل')
  yas = yas.replace(/h/g, 'ا')
  yas = yas.replace(/j/g, 'ت')
  yas = yas.replace(/k/g, 'ن')
  yas = yas.replace(/l/g, 'م')
  yas = yas.replace(/;/g, 'ك')
  yas = yas.replace(/'/g, 'ط')
  yas = yas.replace(/z/g, 'ئ')
  yas = yas.replace(/x/g, 'ء')
  yas = yas.replace(/c/g, 'ؤ')
  yas = yas.replace(/v/g, 'ر')
  yas = yas.replace(/b/g, 'لا')
  yas = yas.replace(/n/g, 'ى')
  yas = yas.replace(/m/g, 'ة')
  yas = yas.replace(/,/g, 'و')
  yas = yas.replace(/\./g, 'ز')
  yas = yas.replace(/\//g, 'ظ')
  //yas = yas.replace(/~/g, ' ّ')
  //yas = yas.replace(/Q/g, 'َ')
  //yas = yas.replace(/W/g, 'ً')
  //yas = yas.replace(/E/g, 'ُ')
  //yas = yas.replace(/R/g, 'ٌ')
  //yas = yas.replace(/T/g, 'لإ')
  yas = yas.replace(/Y/g, 'غ')
  //yas = yas.replace(/U/g, '‘')
  //yas = yas.replace(/I/g, '÷')
  //yas = yas.replace(/O/g, '×')
  //yas = yas.replace(/P/g, '؛')
  //yas = yas.replace(/A/g, 'ِ')
  //yas = yas.replace(/S/g, 'ٍ')
  yas = yas.replace(/G/g, 'ل')
  yas = yas.replace(/H/g, 'ا')
  //yas = yas.replace(/J/g, 'ـ')
  //yas = yas.replace(/K/g, '،')
  //yas = yas.replace(/L/g, '/')
  //yas = yas.replace(/Z/g, '~')
  //yas = yas.replace(/X/g, 'ْ')
  yas = yas.replace(/B/g, 'لآ')
  //yas = yas.replace(/N/g, 'آ')
  //yas = yas.replace(/M/g, '’')
  yas = yas.replace(/A/g, 'ش')
  yas = yas.replace(/F/g, 'ب')
  yas = yas.replace(/O/g, 'خ')
  yas = yas.replace(/P/g, 'ح')
  yas = yas.replace(/D/g, 'ي')
  yas = yas.replace(/J/g, 'ت')
  //yas = yas.replace(/K/g, '،')
  yas = yas.replace(/L/g, 'م')
  yas = yas.replace(/Z/g, 'ئ')
  yas = yas.replace(/X/g, 'ء')
  yas = yas.replace(/\?/g, 'ظ')
  yas = yas.replace(/Q/g, 'ض')
  yas = yas.replace(/W/g,'ص')
  yas = yas.replace(/E/g, 'ث')
  yas = yas.replace(/R/g, 'ق')
  yas = yas.replace(/T/g, 'ف')
  yas = yas.replace(/Y/g, 'غ')
  yas = yas.replace(/U/g, 'ع')
  yas = yas.replace(/I/g, 'ه')
  yas = yas.replace(/N/g, 'ى')
  yas = yas.replace(/M/g, 'ة')
  yas = yas.replace(/V/g, 'ر')
  yas = yas.replace(/C/g, 'ؤ')
  yas = yas.replace(/S/g, 'س')
  yas = yas.replace(/'/g, 'ط')
  yas = yas.replace(/K/g, 'ن')
  return yas
}
export const handleNumberCheck = (e) => {
  const text = e
  let newText = ''
  const numbers = '0123456789.'
  let count = 0

  for (var i = 0; i < text.length; i++) {
    if (numbers.indexOf(text[i]) > -1) {
      newText = newText + text[i]
    } else { count = 1 }
  }
  return count
}
export const handleNumberOnlyCheck = (val) => {
  const numbers = /^[0-9]*$/i
  if (numbers.test(val)) {
    return 1
  }
  return 0
}
